import { useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import {
  ImageIntentContext,
  registerSaveShortcutContext,
} from '../../../../utils/imageIntentReporter';
import {
  resolveGallery,
  selectGalleryDefaults,
} from './imageIntentContextGallery';
import { selectImageProtectionEnabled } from '../../../../selectors/imageIntent';

// Reports Cmd/Ctrl+S to the given surface while the calling component is
// mounted. The keystroke saves the page, not an image, so it is credited to
// the screen rather than to one preview, and it is suppressed (and reported
// blocked) only while the studio has image protection on (ENG-2594). The
// gallery follows resolveGallery: the context's own three fields when it
// names any (NO_IMAGE_INTENT_GALLERY for "none"), else the Redux gallery.
//
// Call it once per screen. With no context (or no surface) it registers
// nothing, which lets useImageIntentFriction call it unconditionally. A
// screen that cannot call hooks (a legacy class component) renders
// ImageIntentSaveShortcut instead.
const useImageIntentSaveShortcut = (context?: ImageIntentContext): void => {
  const galleryDefaults = useSelector(selectGalleryDefaults, shallowEqual);
  const protectionEnabled = useSelector(selectImageProtectionEnabled);

  const surface = context?.surface;
  const { galleryKey, picsGalleryId, dp2GalleryId } = resolveGallery(
    context ?? {},
    galleryDefaults,
  );

  useEffect(() => {
    if (!surface) return undefined;

    return registerSaveShortcutContext(
      {
        surface,
        galleryKey,
        picsGalleryId,
        dp2GalleryId,
      },
      { preventDefault: protectionEnabled },
    );
  }, [surface, galleryKey, picsGalleryId, dp2GalleryId, protectionEnabled]);
};

export default useImageIntentSaveShortcut;
